import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {NgClass, NgIf, NgStyle} from "@angular/common";
import {SafeResourcePipe} from "../../pipes";
import {Alert, CustomButtonAlert, ResponseAlert} from "../../shared";
import {DynamicDialogConfig, DynamicDialogRef} from "primeng/dynamicdialog";
import {ButtonDirective} from "primeng/button";
import {TranslateService} from "@ngx-translate/core";
import {firstValueFrom, forkJoin} from "rxjs";

@Component({
  selector: 'template-alert',
  standalone: true,
  imports: [
    NgIf,
    SafeResourcePipe,
    NgClass,
    ButtonDirective,
    NgStyle
  ],
  template: `
    <main class="w-full h-full flex flex-column">
      <header class="flex flex-column w-full ">
        <i *ngIf="showIcon" class="pi text-7xl align-self-center" [ngClass]="'pi-' + data.icon"></i>
        <h2 *ngIf="data.title?.length" class=" ml-0 mt-3 mb-2 title text-center">{{ data.title }}</h2>
      </header>
      <div class="body mb-2">
        <p *ngIf="data.text" class="app-text-gray font-16 text-center font-principal font-light">{{ data.text }}</p>
        <div *ngIf="data.html" class="text-center" [innerHTML]="data.html | safeResource : 'html' "></div>
      </div>
      <footer>
        <div class="flex gap-4" [class]="data.positionBtn"  >
          <button  *ngIf="buttonCancel.show" class="action-btn btn-blue-general  text-lg"
                   [ngClass]="buttonCancel.class" [disabled]="buttonCancel.disabled"
                   [icon]="buttonCancel.icon ?? ''" [ngStyle]="buttonCancel.style"
                   (click)="buttonCancel.action ? buttonCancel.action() : close()" pButton
                   [label]="buttonCancel.label"></button>

          <button *ngIf="buttonAccept.show" class="action-btn btn-blue-general text-lg"
                  [ngClass]="buttonAccept.class" [disabled]="buttonAccept.disabled"
                  [icon]="buttonAccept.icon ?? ''" [ngStyle]="buttonAccept.style"
                  (click)="buttonAccept.action ? buttonAccept.action() : acceptHandler()" pButton
                  [label]="buttonAccept.label"></button>
        </div>
        <ng-content select="#footer"></ng-content>
      </footer>
    </main>
  `,
  styles: `
    .title {
      color: #256390;
    }

    .left {
      justify-content: start
    }

    .center {
      justify-content: center;
    }

    .font-principal {
      font-family: "roboto", 'Assistant', sans-serif;
    }
    .font-16 {
      font-size: 1.43rem;
    }
    .right {
      justify-content: end;
    }

    .btn-blue-general {
      background: var(--general-blue);
      font-weight: var(--font-regular);

      &:hover {
        background: var(--general-blue-hover);
        border: var(--general-blue-hover);
      }
    }

    .action-btn {

      border:none;
      padding: 1rem;

      &:focus{
        box-shadow:none;
      }
    }

    .border-23 {
      border-radius: 23px;
    }

    [class*='check-'] {
      color: #57B747;
    }

    [class*='info-'],  [class*='question-'] {
      color: #96C6E6;
    }

    [class*='exclamation-'] {
      color: #fdc41d;
    }
    [class*='times-'] {
      color: #DB2828;
    }
  `
})
export class TemplateAlertComponent implements  OnInit{
  data: Alert;
  buttonCancel!: CustomButtonAlert;
  buttonAccept!: CustomButtonAlert;
  traslations:any = {};


   constructor( public config: DynamicDialogConfig, private ref:DynamicDialogRef, private _t:TranslateService ) {
     this.data = this.config.data;

     if (!this.data.positionBtn){
       this.data.positionBtn = "center";
     }
     this.initButtons();

   }

  async ngOnInit() {
     this.traslations =  await firstValueFrom(forkJoin({
         accept: this._t.get('form.button.aceptar'),
         cancel: this._t.get('form.button.cancelar'),
       }));
     if (this.buttonAccept?.show && !this.buttonAccept?.label)this.buttonAccept.label = this.traslations.accept;
     if (this.buttonCancel?.show && !this.buttonCancel?.label)this.buttonCancel.label = this.traslations.cancel;
  }

  initButtons(){
    if (this.data.cancelButton) {
      this.buttonCancel = this.data.cancelButton;
      if (this.buttonCancel.show == undefined) {
        this.buttonCancel.show = true;
      }
    } else {
      this.buttonCancel = {
        label: this.data.textCancel ?? '',
        show: this.data.showCancel ?? false,
        class: 'border-23'
      };
    }
    if (this.data.acceptButton) {
      this.buttonAccept = this.data.acceptButton;
      if (this.buttonAccept.show == undefined) {
        this.buttonAccept.show = true;
      }
    } else {
      this.buttonAccept = {
        label: this.data.textAccept ?? '',
        show: this.data.showAccept ?? false,
        class: 'border-23'
      };
    }
  }

  close(){
     this.ref.close({'cancel':true} as ResponseAlert);
  }

  acceptHandler(){
     this.ref.close({'accept':true} as ResponseAlert);
  }

  get showIcon(): boolean {
    return this.data.showIcon ?? true;
  }

}
